import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {BsModalRef } from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {HoSoService} from '../../../../service/hoso/service-hoso';
import {HoSoFileService} from '../../../../service/hoso/service-hosofile';
import {Subject} from 'rxjs';
import {HoSoFile} from '../../../../models/hoso/hosofile';
import {HoSo} from '../../../../models/hoso/hoso';
import {CommandUtil} from '../../../../global/commandutil';
import {HoSoShareService} from '../../../../service/hoso/service-hososhare';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {HoSoXuLyService} from '../../../../service/hoso/service-hosoxuly';
import {HoSoXuLy} from '../../../../models/hoso/hosoxuly';
import {DatePipe} from '@angular/common';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  templateUrl: './detail.component.html'

})
export class DetailHoSoComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public hoSoItem: HoSo = new HoSo();
  public hoSoFile: HoSoFile[] = [];
  public language = language;
  public onClose: Subject<boolean>;
  public hoSoXuLyList: HoSoXuLy[] = [];
  constructor( public hoSoService: HoSoService,
               public toastr: ToastrService,
               public hoSoFileService: HoSoFileService,
               public _bsModalRef: BsModalRef,
               public commandUtil: CommandUtil,
               public hoSoShareService: HoSoShareService,
               public hoSoXuLyService: HoSoXuLyService,
               public datePipe: DatePipe,
               public sanitizer: DomSanitizer

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }

  public edit(id: number) {
    this.hoSoService.getById(id).pipe(first())
      .subscribe(x => this.hoSoItem = x);
    this.hoSoXuLyService.findAllByHoSoId(id).subscribe(dataList => this.hoSoXuLyList =dataList);

    this.hoSoFileService.findAllByHoSoId(id).subscribe(
      x => {
        this.hoSoFile = x;
      });
    this.hoSoShareService.updateShare(id, Sessioncommand.staffId).subscribe( {

      next: () => {
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });


  }


  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

